import { EventEmitter } from '@angular/core';
import { ButtonsActionsTableComponent } from '@app/shared';

export class UsersTaskConfig{
  // Se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // Configuraciones de la tabla
  settings = {};
  settingsUser = {};

  constructor() {
    const self = this;
    this.settings = {
      selectMode: 'multi',
      mode: 'external',
      noDataMessage: 'La tarea actual no contiene responsables',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        responsable: {
          title: 'Responsable',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
          },
          width: '98%',
        }
      },
    };
    this.settingsUser = {
      selectMode: 'multi',
      mode: 'external',
      noDataMessage: 'No hay usuarios disponibles',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        identificacion: {
          title: 'Indetificación',
          class: 'prueba',
          filter: {
            inputClass: 'form-control',
            width: '24%',
          },
        },
        nombre: {
            title: 'Nombre',
            class: 'prueba',
            filter: {
              inputClass: 'form-control',
            },
            width: '37%',
          },
        apellido: {
            title: 'Apellido',
            class: 'prueba',
            filter: {
              inputClass: 'form-control',
            },
            width: '37%',
          }
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/users-task-management/shared/users-task-management.config.service.ts